import React from "react"
import {
  createStyles,
  HTMLStyledProps,
  styled,
} from "@design-system/styled-system"
import { LayoutValue } from "@design-system/hooks"

export interface TabIndicatorProps extends HTMLStyledProps<"span"> {
  tabLayout?: LayoutValue
}

export function TabIndicator(props: TabIndicatorProps) {
  const { style, tabLayout } = props
  if (!tabLayout) {
    return null
  }

  return (
    <styled.span
      style={[
        styles.root,
        tabLayout && {
          left: `${tabLayout.x}px`,
          width: `${tabLayout.width}px`,
        },
        style,
      ]}
    />
  )
}

TabIndicator.displayName = "TabIndicator"

const styles = createStyles((theme) => ({
  root: {
    position: "absolute",
    bottom: 0,
    height: 3,
    borderRadius: "6px",
    backgroundColor: theme.backgroundColors.selection,
    zIndex: 100,
  },
  animation: {
    transitionProperty: "all",
    transitionDuration: "0.25s",
    transitionTimingFunction: "ease-in-out",
  },
}))
